import React from "react";
import './DiSignal.css'

export default function DiSignal ({numberDi, onOfDi}) {

    return (
        <div className={`DiSignalPch ${onOfDi === 'On' ? "DiSignalPch-On" : "DiSignalPch-Off"}`}>
        {numberDi}
        </div>
    )
}
